import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M21.5999 11.9999L16.7999 17.1999M21.5999 11.9999L16.7999 7.1999M21.5999 11.9999H6.3999M12.7999 21.5999H2.3999V2.3999H12.7999",
      stroke: "black"
    }, null, -1)
  ])))
}
export default { render: render }